"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "TrackerTest";

export default {
  getAllTrackerTests() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllTrackerTests`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  saveTrackerTest(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveTrackerTest`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  getActualValuesFromTracker(payload) {
    return new Promise(resolve => {
      ApiService.post(
        `${baseURL}/GetActualValuesFromTracker`,
        payload
      ).result.then(({ data }) => {
        resolve(data);
      });
    });
  },
  getOneTrackerTest(testId) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetOneTrackerTest`, `?testID=${testId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  deleteTrackerTest(testId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/DeleteTrackerTest?testID=${testId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
